function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// semeia-disable-reexport

export class AbstractCnamApiError extends Error {
  constructor(message = "", error = undefined) {
    super(message);
    this.error = error;
  }
}
export class CnamApiInsError extends AbstractCnamApiError {
  constructor(message = "", error = undefined, identity) {
    super(message, error);
    _defineProperty(this, "name", "cnam-api-ins-error");
    this.error = error;
    this.identity = identity;
  }
}
export class CnamApiInsNoIdentityFoundError extends CnamApiInsError {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "name", "cnam-api-ins-no-identity-found-error");
  }
}
export class CnamApiInsMultipleIdentityFoundError extends CnamApiInsError {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "name", "cnam-api-ins-multiple-identity-found-error");
  }
}
export class CnamApiInsIdentityCorruptedError extends CnamApiInsError {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "name", "cnam-api-ins-identity-corrupted-error");
  }
}
export class CnamApiInsMandatoryInfoMissingError extends CnamApiInsError {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "name", "cnam-api-ins-mandatory-info-missing-error");
  }
}
export class CnamApiInsConflictWithSsnError extends CnamApiInsError {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "name", "cnam-api-ins-conflict-with-ssn-error");
  }
}
export class CnamApiInsNoSexError extends CnamApiInsError {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "name", "cnam-api-ins-no-sex-error");
  }
}
export class CnamApiInsBirthdayInvalidError extends CnamApiInsError {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "name", "cnam-api-ins-birthday-invalid-error");
  }
}
export class CnamApiInsPatientInvalid extends CnamApiInsError {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "name", "cnam-api-ins-patient-invalid");
  }
}
export class CnamApiCpsCardInfosMissing extends AbstractCnamApiError {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "name", "cnam-api-cps-card-infos-missing");
  }
}

// Error class for low level DmpConnectJS errors
export class CnamApiError extends AbstractCnamApiError {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "name", "cnam-api-error");
  }
}
export class CnamApiVitaleCardError extends AbstractCnamApiError {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "name", "cnam-api-vitale-card-error");
  }
}
export class CnamApiCpsCardError extends AbstractCnamApiError {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "name", "cnam-api-cps-card-error");
  }
}
export class CnamApiCpsNoBillingNumber extends CnamApiCpsCardError {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "name", "cnam-api-cps-no-billing-number");
  }
}
export class CnamApiCpsNoPracticeLocations extends CnamApiCpsCardError {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "name", "cnam-api-cps-no-practice-locations");
  }
}
export class CnamApiCpsCardWrongCode extends AbstractCnamApiError {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "name", "cnam-api-cps-card-wrong-code");
  }
}
export class CnamApiCpsCardBlocked extends AbstractCnamApiError {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "name", "cnam-api-cps-card-blocked");
  }
}

// If the medic is blacklisted from this DMP
export class CnamApiDmpAuthorizationDenied extends AbstractCnamApiError {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "name", "cnam-api-dmp-authorization-denied");
  }
}

// The DMP is closed and must be re-opened
export class CnamApiDmpStatusClosed extends AbstractCnamApiError {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "name", "cnam-api-dmp-status-closed");
  }
}

// The DMP has not been created yet
export class CnamApiDmpStatusNotFound extends AbstractCnamApiError {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "name", "cnam-api-dmp-status-not-found");
  }
}

// No reimbursement file found in the DMP
export class CnamApiDmpNoReimbursementDocument extends AbstractCnamApiError {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "name", "cnam-api-dmp-no-reimbursement-document");
  }
}
export class CnamApiDmpReimbursementDocumentFormatNotSupported extends AbstractCnamApiError {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "name", "cnam-api-dmp-reimbursement-document-format-not-supported");
  }
}
export class CnamApiDmpDocumentFailedToSave extends AbstractCnamApiError {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "name", "cnam-api-dmp-document-failed-to-save");
  }
}
export class CnamApiDmpParsingFileError extends AbstractCnamApiError {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "name", "cnam-api-dmp-parsing-file-error");
  }
}
export class CnamApiDmpConnectJSNotAvailable extends AbstractCnamApiError {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "name", "cnam-api-dmpconnect-js-not-available");
  }
}